<template>
  <div class="login-container">
    <MglMap
      :accessToken="accessToken"
      :mapStyle="style"
      :maxZoom="2"
      :minZoom="2"
      :center="[15, 25]"
      style="position: absolute; z-index: 0"
      @load="onMapLoaded"
    >
      <SimpleMarker
        v-for="vessel in markers"
        :key="vessel.idVessel"
        :coordinates="vessel.coordinates"
        :icon="vessel.icon"
        :color="vessel.color"
      />
    </MglMap>
    <div class="login-content">
      <div class="logo-section">
        <img
          src="/VesselQUAD.ico"
          alt="Vessel QUAD Logo"
          class="logo-icon"
          width="150"
          height="150"
        />
      </div>
      <h1 class="login-title">Welcome to VesselQUAD</h1>
      <CustomThemedButton
        @click="loginWithProvider"
        block
        color="secondary"
        :loading="loginLoading"
      >
        <div class="login-button-content">
          <font-awesome-icon :icon="['fab', 'microsoft']" />
          <span>Login</span>
        </div>
      </CustomThemedButton>
      <span v-show="loginError" class="login-error">{{ loginError }}</span>
    </div>
  </div>
</template>
  
<script>
import CustomThemedButton from "@/core/CustomThemedButton.vue";
import { MglMap } from "vue-mapbox";
import SimpleMarker from "./components/SimpleMarker.vue";

export default {
  name: "Login",
  components: {
    CustomThemedButton,
    MglMap,
    SimpleMarker,
  },
  data() {
    return {
      accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
      style: "mapbox://styles/kyroiko/cmcn9jzdh00ad01sbd5jl3gs6",
      markers: [
        {
          coordinates: [-74.0059, 40.7128],
        },
        {
          coordinates: [-15.3522, 58.8566],
        },
        {
          coordinates: [139.6917, 35.6895],
        },
        {
          coordinates: [-122.4194, 37.7749],
        },
        {
          coordinates: [151.2093, -33.8688],
        },
        {
          coordinates: [-43.1729, -22.9068],
        },
        {
          coordinates: [103.8198, 1.3521],
        },
        {
          coordinates: [18.4241, -33.9249],
        },
        {
          coordinates: [121.4737, 31.2304],
        },
      ],
      loginLoading: false,
      loginError: null,
    };
  },
  methods: {
    onMapLoaded(event) {
      event.map.getCanvas().style.cursor = "default";
      event.map.dragRotate.disable();
      event.map.touchZoomRotate.disable();
      event.map.doubleClickZoom.disable();
      event.map.scrollZoom.disable();
      event.map.keyboard.disable();
      event.map.scrollZoom.disable();
      event.map.touchZoomRotate.disable();
      event.map.dragPan.disable();
    },

    getErrorMessage(error) {
      // Map error types to user-friendly messages
      const errorMessages = {
        ACCESS_DENIED:
          "You do not have permission to access this application. Please contact your administrator.",
        LOGIN_FAILED:
          "Login failed. Please try again or contact support if the problem persists.",
      };

      return (
        errorMessages[error.message] ||
        error.cause ||
        "An unexpected error occurred during login."
      );
    },

    async loginWithProvider() {
      sessionStorage.clear();
      this.loginLoading = true;
      this.loginError = null;
      try {
        const accessToken = await this.$msal.signIn();
        if (accessToken) {
          localStorage.setItem("quad_token", accessToken);
          this.$router.push("/");
        }
      } catch (error) {
        this.loginError = this.getErrorMessage(error);
      } finally {
        this.loginLoading = false;
        setTimeout(() => {
          this.loginError = null;
        }, 3000);
      }
    },
  },
};
</script> 
  
<style scoped>
.login-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background: var(--gradient-primary);
}

.login-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  border-radius: 10px;
  padding: 68px;
  width: 500px;
  background: var(--gradient-overlay);
  border: 1px solid var(--color-border);
  z-index: 1;
}

.login-title {
  color: var(--color-text);
}

.logo-section {
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--gradient-accent);
  border-radius: 10px;
  padding: 20px;
}

.login-button-content {
  display: flex;
  align-items: center;
  gap: 10px;
}
.login-error {
  color: var(--color-error);
}
</style>
  
  
  